import { AppState } from "../../../redux-configuration/AppState";

export const isCreatingInstantSelector = (state: AppState): boolean => state.managementInstant.createInstant.isLoading
export const createInstantSuccessSelector = (state: AppState): boolean | null => state.managementInstant.createInstant.success
export const createInstantErrorSelector = (state: AppState): string | undefined => state.managementInstant.createInstant.error
